import * as tslib_1 from "tslib";
import { KeyControlAndAbstractSearchCriteria } from './key-control-and-abstract-search-criteria';
var ConfigurationSearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(ConfigurationSearchCriteria, _super);
    function ConfigurationSearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.code = '';
        return _this;
    }
    return ConfigurationSearchCriteria;
}(KeyControlAndAbstractSearchCriteria));
export { ConfigurationSearchCriteria };
